import { useSelectedClient } from '@entities/clients/heplers.ts';
import { useClients } from '@entities/clients/index.ts';
import { useGetClientsQuery } from '@entities/clients/rtk-query.ts';
import type { ClientsListQueryParams } from '@entities/clients/types.ts';
import { memo, useEffect, useLayoutEffect, useMemo, useState } from 'react';
import { InfinityList } from '@widgets/shared/InfinityList/index.tsx';
import { useSaveScroll } from '@shared/hooks/use-save-scroll.ts';
import type { Client } from '@shared/types/users';
import { Blank } from '@src/library/components/common';
import { ClientCardSmall } from '../card';
import * as st from './styles.module.scss';

interface Props {
  params: Omit<ClientsListQueryParams, 'page'>;
  setShowRightBlock: (showRightBlock: boolean) => void;
}

export const ClientList: React.FC<Props> = memo(({ params, setShowRightBlock }) => {
  const { setListScrollData, cacheData } = useSaveScroll('ClientsMobileList');

  const [page, setPage] = useState(cacheData?.pageNumber || 1);

  const { setClients, setCountOfClients } = useClients();

  const { data, isLoading, isFetching } = useGetClientsQuery(
    { page, ...params },
    {
      refetchOnMountOrArgChange: Boolean(params?.not_custom_group),
    }
  );
  const clients = useMemo(() => data?.results || [], [data]);
  // console.log("clients: ", clients);
  // console.log("data: ", data);

  const { selectedClient, setSelectedClient } = useSelectedClient();
  const onLoadMore = () => setPage((page) => page + 1);

  useLayoutEffect(() => {
    setPage(cacheData?.pageNumber || 1);
  }, [params?.search]);

  useLayoutEffect(() => {
    setCountOfClients(0);
  }, []);

  useEffect(() => {
    if (data) {
      setClients(data.results);
      setCountOfClients(data.count);
    }
  }, [data]);

  useEffect(() => {
    if (clients.length > 0) {
      !selectedClient && setSelectedClient(clients[0]);
      setShowRightBlock(true);
    } else {
      setShowRightBlock(false);
    }
  }, [clients, setShowRightBlock, selectedClient, setSelectedClient]);

  return (
    <div className={st.list}>
      <InfinityList
        hasMore={Boolean(data?.next)}
        loadMore={onLoadMore}
        loading={isLoading || (isFetching && page !== 1)}
        className={st.scroller}
      >
        {clients.map((item: Client) => (
          <ClientCardSmall
            key={item.id}
            onClick={() => {
              setListScrollData({ scrollY: window.scrollY, pageNumber: page });
            }}
            client={item}
          />
        ))}
        {!isLoading && clients.length === 0 && (
          <Blank
            text={
              params.search
                ? 'По вашему запросу ничего не найдено'
                : 'В этом списке пока нет клиентов'
            }
          />
        )}
      </InfinityList>
    </div>
  );
});
